import Http from "@/commons/Http";
import Utils from "@/commons/Utils.js";

const path = 'api/tabela-custa';

export default {

  async getTiposRegistro(dominio = null) {
    let tipos = await Http.get(`${path}/tipo-registro/${dominio || ''}`).catch((e) => e);
    return Utils.uniqBy(tipos, 'id');
  },

  async getTiposPrimeiraAquisicao() {
    return Http.get(`${path}/tipo-registro/primeira-aquisicao`);
  },

  async getTiposPrimeiraAquisicaoPadraoSim() {
    return Http.get(`${path}/tipo-registro/primeira-aquisicao/padrao-sim`);
  },

  async getTabelas(estado) {
    return await Http.get(`${path}/${estado}`);
  },

  async getCustasTabela(estado, inicio, fim) {
    return await Http.get(`${path}/${estado}/custas/${inicio}/${fim}`);
  },

  listTiposRegistro(estado){

    let tipos = [
      { id : "NORMAL", nome : "Normal"},
      { id : "PRIMEIRA_AQUISICAO", nome : "Primeira Aquisição - SFH"},
      { id : "PMCMV", nome : "Programa Minha Casa Minha Vida - PMCMV"},
      { id : "PCVA", nome : "Programa Casa Verde e Amarela - PCVA"},
      { id : "FAR", nome : "Fundo de Arrendamento Residencial - FAR"},
    ];

    if (!estado || estado == 'MS') {
      tipos.push({ id : "PRIMEIRA_AQUISICAO_25", nome : "Primeira Aquisição - SFH (25%)"});
      tipos.push({ id : "PAR", nome : "Programa de Arrendamento Residencial - PAR"});
    }

    if (!estado || estado == 'RS') {
      tipos.push({ id : "PRIMEIRA_AQUISICAO_25", nome : "Primeira Aquisição - SFH (25%)"});
      tipos.push({ id : "PAR", nome : "Programa de Arrendamento Residencial - PAR"});
      tipos.push({ id : "COHAB", nome : "COHAB"});
      tipos.push({ id : "MEU", nome : "Município, Estado ou União"});
      tipos.push({ id : "MUNICIPIO", nome : "Município"});
    }
    if(!estado || estado == 'GO'){
      tipos.push({ id : 'ADJUDICACAO_COMPULSORIA', nome : 'Adjudicação Compulsória'});
      tipos.push({ id : "DESAPROPRIACAO", nome : "Desapropriação Empresas Públicas e Sociedades de Economia Mista"});
      tipos.push({ id : 'CEDULA', nome : 'Cédula ou Aditivo de Cédula'});
      tipos.push({ id : 'CEDULA_RURAL', nome : 'Cédula Rural ou Aditivo de Cédula'});
      tipos.push({ id : 'PAGAMENTO_POSTERIOR', nome : 'Pagamento Posterior'});
      tipos.push({ id : 'USUCAPIAO_EXTRAJUDICIAL', nome : 'Usucapião Extrajudicial'});
      tipos.push({ id : 'ISENTO', nome : 'Prenotação Isenta'});
      tipos.push({ id : 'PAGAMENTO_POSTERIOR_CNIB', nome : 'Pagamento Posterior (CNIB)'});
      tipos.push({ id : 'CNIB_CANCELAMENTO', nome : 'Cancelamento de Ordem CNIB'});
      tipos.push({ id : 'DESAPROPRIACAO', nome : 'Desapropriação Empresas Públicas e Sociedades de Economia Mista'});
      tipos.push({ id : 'PAGAMENTO_POSTERIOR_PENHORA_TRABALHISTA', nome : 'Pagamento Posterior (Penhora Trabalhista)'});
      tipos.push({ id : 'PAGAMENTO_POSTERIOR_EXECUCAO_FISCAL', nome : 'Pagamento Posterior (Execução Fiscal)'});
      tipos.push({ id : 'DESENQUADRAMENTO', nome : 'Desenquadramento do PMCMV'});
      tipos.push({ id : 'REURB', nome : 'Reurb (Lei 13.465/2017)'});
      tipos.push({ id : "PAR", nome : "Programa de Arrendamento Residencial - PAR"});
    }

    if(!estado || estado == 'SC'){
      tipos.push({ id : "PAR", nome : "Programa de Arrendamento Residencial - PAR"});
      tipos.push({ id : "COHAB", nome : "COHAB"});
      tipos.push({ id : "MORAR_MELHOR", nome : "Habitacional Morar Melhor"});
      tipos.push({ id : "CONSTRICAO_JUDICIAL", nome : "Constrições judiciais"});
      tipos.push({ id : "OUTRAS_AUTARQUIAS", nome : "Autarquias de outros Estados"});
      tipos.push({ id : "NORMAL_SEM_FRJ", nome : "Normal (Sem incidência de FRJ)"});
      tipos.push({ id : "NORMAL_DESCONTO_FRJ", nome : "Normal (FRJ 5%) - Crédito Rural"});
      tipos.push({ id : "PAGAMENTO_DIFERIDO", nome : "Normal (pagamento diferido)"});

    }

    if(!estado || estado == 'CE'){
      tipos = tipos.filter(e => e.id !== "FAR")
      tipos.push({ id : "PAR", nome : "Programa de Arrendamento Residencial - PAR"});
      tipos.push({ id : "COHAB", nome : "COHAB"});
      tipos.push({ id : "MANDADO_JUDICIAL", nome : "Mandado Judicial"});
      tipos.push({ id : "FAR", nome : "Fundo de Arrendamento Residencial - FAR 75%"});
      tipos.push({ id : "FAR_50", nome : "Fundo de Arrendamento Residencial - FAR 50%"});
    }

    if(!estado || estado == 'BA'){
      tipos.push({ id : "FAR_50", nome : "Fundo de Arrendamento Residencial - FAR 50%"});
    }

    if(!estado || estado == 'PE'){
      tipos.push({ id : "AQUISICAO_COOPERATIVA_HABITACIONAL", nome : "Aquisição por Cooperativa Habitacional"});
      tipos.push({id:"REURB_S", nome: "Reurb-S"});
    }

    if(!estado || estado == 'PR') {
      tipos.push({ id : "PRIMEIRA_AQUISICAO_25", nome : "Primeira Aquisição - SFH (25%)"});
      tipos.push({ id : "PRIMEIRA_AQUISICAO_20", nome : "Primeira Aquisição - SFH (20%)"});
      tipos.push({ id : "DESCONTO_ENTES_PUBLICOS", nome : "Entes Públicos"});
      tipos.push({ id : "COHAPAR", nome : "COHAPAR"});
      tipos.push({ id : "ORDEM_JUDICIAL", nome: "Ordem Judicial - 25% de Desconto"});
      tipos.push({ id : "ORDEM_JUDICIAL_50_DESCONTO", nome: "Ordem Judicial - 50% de Desconto"});
      // tipos.push({ id : "ORDEM_JUDICIAL_80_DESCONTO", nome: "Ordem Judicial - 80% de Desconto"});
    }

    if(!estado || estado == 'RO') {
      tipos.push({ id : "PRIMEIRA_AQUISICAO_25", nome : "Primeira Aquisição - SFH (25%)"});
      tipos.push({ id : "PMCMV_25", nome : "Programa Minha Casa Minha Vida - PMCMV (25%)"});
      tipos.push({ id : "REGULARIZACAO_FUNDIARIA", nome : "Regularização Fundiária"});

    }

    if(!estado || estado == 'MG'){
      tipos.push({ id : "PAR", nome : "Programa de Arrendamento Residencial - PAR"});
      tipos.push({ id : "DOACAO_ESTADO", nome : "Doação de Imóveis pelo Estado"});
      tipos.push({ id : "INDISPONIBILIDADE", nome : "Indisponibilidade de Bens"});
      tipos.push({ id : "MANDADO_JUDICIAL", nome : "Mandado Judicial"});
      tipos.push({ id : "CANCELAMENTO_PENHORA_TRABALHISTA", nome : "Cancelamento de Penhora Trabalhista"});
      tipos.push({ id : "PENHORA_ONLINE_SAEC", nome : "Penhora Online - SAEC"});
      tipos.push({ id : "RURAL_HAP", nome : "Rural - Hip., Al. Fid. e Penhor"});
      tipos.push({ id : "RURAL_PRONAF_DAP_HAP", nome : "Rural Pronaf. Dap. - Hip., Al. Fid. e Penhor"});
      tipos.push({ id : "COMPROMISSO_COMPRA_VENDA", nome : "Compromisso de Compra e Venda"});
      tipos.push({ id : "ATO_SOCIEDADE_CIVIL", nome : "Ato Constitutivo de Sociedade Civil"});
      tipos.push({ id : "GARANTIA_CREDITO_RURAL_50", nome : "Desconto para registro de garantias decorrentes do crédito rural (50%)"});
      tipos.push({ id : "GARANTIA_CREDITO_RURAL_75", nome : "Desconto  para registro de garantias decorrentes do crédito rural (75%)"});
      tipos.push({ id : "REGISTRO_PROMESSA", nome : "Desconto 50% - Registro de promessa de compra e venda, cessão e promessa de permuta"});
    }

    if(!estado || estado == 'SP'){
      tipos.push({ id : "PRIMEIRA_AQUISICAO_25", nome : "Primeira Aquisição - SFH (25%)"});
      tipos.push({ id : "DESCONTO_ENTES_PUBLICOS", nome : "Entes Públicos"});
      tipos.push({ id : "ISENTO_FUNDOS", nome : "Isento de Fundos"});
      tipos.push({ id : "SOCIEDADE_SEM_FINS_LUCRATIVOS", nome : "Sociedade sem Fins Lucrativos"});
      tipos.push({ id : "EMPREENDIMENTO_INTERESSE_SOCIAL_ZEIS", nome : "Empreendimentos de Interesse Social - Zeis"});
      tipos.push({ id : "CALCULO_PARCIAL", nome : "Cálculo Parcial"});
      tipos.push({ id : "SEM_ISS", nome: "Sem incidência de ISS"});
      tipos.push({ id : "TABELA_80", nome : "Tabela 80%"});
    }

    if(!estado || estado === 'MA') {
      tipos.push({ id : "REURB_S", nome : "Reurb-S"});
      tipos.push({ id : "PROGRAMA_HABITACAO_POPULAR", nome : "Programa de Habitação Popular"});
      tipos.push({ id : 'PAGAMENTO_POSTERIOR', nome : 'Pagamento Posterior'});
      tipos.push({ id : "PRIMEIRA_AQUISICAO_ART290", nome : "Primeira Aquisição - art. 290, da Lei nº 6.015/1973"});
      tipos.push({ id : 'PMCMV_PVCA_ART42', nome : 'PMCMV/PVCA – Incorporação, Construção e Outros - art. 42, inciso II, da Lei nº 11.977/2009'});
      tipos.push({ id : 'PMCMV_PVCA_ART43', nome : 'PMCMV/PVCA - art. 43, inciso II, da Lei nº 11.977/2009'});
      tipos.push({ id : 'FAR_ADQUIRIDO', nome : 'FAR – ADQUIRINDO - art. 42, inciso I, § 1º, da Lei nº 11.977/2009 (75%)'});
      tipos.push({ id : 'FAR_TRANSFERIDO', nome : 'FAR - TRANSFERINDO - art. 35, da Lei nº 10.150/2000 (50%)'});
    }

    if(!estado || estado === 'MT'){
      tipos.push({ id : "PAGAMENTO_DIFERIDO", nome : "Normal (pagamento diferido)"});
      tipos.push({ id : "USUCAPIAO", nome : "Usucapião"});
    }

    return Utils.uniqBy(tipos, 'id');

  }

}
